module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "container section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "settings-menu"
  }, [_c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'general'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'general'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-cogs"
  }), _vm._v("\n                         \n                        Generelt\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'accountPlan'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'accountPlan'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-list"
  }), _vm._v("\n                         \n                        Kontoplan\n                    ")]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'valuechainCalculation'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'valuechainCalculation'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-calculator"
  }), _vm._v("\n                         \n                        Værdikæde kalkulation\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'employees'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'employees'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-users"
  }), _vm._v("\n                         \n                        Medarbejdere\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'projectStatuses'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'projectStatuses'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-briefcase"
  }), _vm._v("\n                         \n                        Opgavestatus\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'excludeProjects'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'excludeProjects'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-times"
  }), _vm._v("\n                         \n                        Skjul opgaver\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'timeloggingTypes'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'timeloggingTypes'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-clock"
  }), _vm._v("\n                         \n                        Tidsregistreringstyper\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), (['admin', 'super-admin'].includes(_vm.$auth.user().roles[0].name)) ? _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'users'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'users'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-users"
  }), _vm._v("\n                         \n                        Systembrugere\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'user'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'user'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-user"
  }), _vm._v("\n                         \n                        Din profil\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-weight": "bold",
      "margin-bottom": "30px",
      "font-family": "'Montserrat'"
    }
  }, [_vm._v("\n                        Justering af information på opgaverne\n                    ")]), _vm._v(" "), (_vm.$store.state.config.availableDepartments.length > 2) ? _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'cleanup'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'cleanup'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-broom"
  }), _vm._v("\n                         \n                        Opgaver uden afdeling\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'projectsMissingBudget'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'projectsMissingBudget'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-divide"
  }), _vm._v("\n                         \n                        Opgaver uden budget\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9"
  }, [(_vm.selected === 'accountPlan') ? _c('accountPlan') : _vm._e(), _vm._v(" "), (_vm.selected === 'employees') ? _c('employees') : _vm._e(), _vm._v(" "), (_vm.selected === 'general') ? _c('general') : _vm._e(), _vm._v(" "), (_vm.selected === 'projectStatuses') ? _c('projectStatuses') : _vm._e(), _vm._v(" "), (_vm.selected === 'cleanup') ? _c('cleanup') : _vm._e(), _vm._v(" "), (_vm.selected === 'users') ? _c('users') : _vm._e(), _vm._v(" "), (_vm.selected === 'user') ? _c('user') : _vm._e(), _vm._v(" "), (_vm.selected === 'budget') ? _c('budget') : _vm._e(), _vm._v(" "), (_vm.selected === 'valuechainCalculation') ? _c('valuechain-calculation') : _vm._e(), _vm._v(" "), (_vm.selected === 'excludeProjects') ? _c('exclude-projects') : _vm._e(), _vm._v(" "), (_vm.selected === 'projectsMissingBudget') ? _c('projects-missing-budget') : _vm._e(), _vm._v(" "), (_vm.selected === 'timeloggingTypes') ? _c('timelogging-types-settings') : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60f315bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/index.vue
// module id = 883
// module chunks = 0